import React from 'react';

const CheckIconPath = () => (
    <path
        fillRule="evenodd"
        d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.052-.143z"
        clipRule="evenodd"
    />
);

export type CustomCheckboxProps = {
    id: string;
    checked: boolean;
    onChange: () => void;
    className?: string;
    disabled?: boolean;
    label?: string;
};

export const CustomCheckbox: React.FC<CustomCheckboxProps> = ({
    id,
    checked,
    onChange,
    className = '',
    disabled = false,
    label,
}) => {
    const handleKeyDown = (e: React.KeyboardEvent<HTMLLabelElement>) => {
        if (!disabled && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault();
            onChange();
        }
    };

    return (
        <div className={`relative flex items-center ${className}`}>
            <input
                type="checkbox"
                id={id}
                checked={checked}
                onChange={disabled ? undefined : onChange}
                disabled={disabled}
                className="sr-only"
            />

            <div
                aria-hidden="true"
                className={[
                    'h-5 w-5 shrink-0 rounded border',
                    'flex items-center justify-center',
                    'transition-all duration-150 ease-in-out',
                    'pointer-events-none',
                    disabled
                        ? checked
                            ? 'bg-gray-300 border-gray-300'
                            : 'bg-gray-100 border-gray-300'
                        : checked
                        ? 'bg-blue-600 border-blue-600'
                        : 'bg-white border-gray-400',
                ].join(' ')}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className={[
                        'h-4 w-4',
                        'transform transition-all duration-200 ease-in-out',
                        checked ? 'scale-100 opacity-100' : 'scale-0 opacity-0',
                        disabled ? 'text-gray-500' : 'text-white',
                    ].join(' ')}
                >
                    <CheckIconPath />
                </svg>
            </div>

            <label
                htmlFor={id}
                onKeyDown={handleKeyDown}
                className={[
                    label ? 'ml-2 text-sm select-none' : 'absolute inset-0',
                    disabled
                        ? 'text-gray-400 cursor-not-allowed'
                        : 'text-gray-700 cursor-pointer',
                ].join(' ')}
            >
                {label ?? null}
            </label>
        </div>
    );
};